export default __webpack_public_path__ + "static/media/undraw1.7de22087.svg";